import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import { clearToast } from "../../../State/toastSlice";
import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";
import NewDashHeader from "./NewDashHeader";
import NewDashFooter from "./NewDashFooter";
import NewLandingHeader from "../../home/NewLayout/NewLandingHeader";
import { ToastAlert } from "../../../components/Dashcomponents/New/ToastAlert";

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

function NewDashLayout() {
  const userlogin = useSelector((state) => state.auth);
  const isLoggedIn = userlogin?.isAuthenticated;
  const userType = userlogin.accountType;
  const shouldAddSidebarMargin = isLoggedIn && Number(userType) !== 2;
  const { message, type, showToast } = useSelector((state) => state.toast);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!showToast || !message) return;

    toast(<ToastAlert type={type || "success"} message={message} />, {
      toastId: `${type || "success"}-${message}`,
      onClose: () => dispatch(clearToast()),
    });
  }, [showToast, message, type, dispatch]);

  return (
    <>
      {/* <Elements stripe={stripePromise}> */}
      <div className="bg-[#030021] min-h-screen relative font-dm-sans ">
        {/* {isLoggedIn && } */}
        {isLoggedIn ? <NewDashHeader /> : <NewLandingHeader />}
        {/* Main Content Area - adds left margin on desktop for sidebar */}
        <div
          className={` pt-[60px]  ${shouldAddSidebarMargin ? "lg:ml-[260px] pt-[60px]" : ""}`}
        >
          <Outlet />
          <NewDashFooter />
        </div>
      </div>
      {/* </Elements> */}
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        closeButton={false}
        icon={false}
        hideProgressBar
        newestOnTop
        toastClassName={() => "!bg-transparent !shadow-none !p-0 !mb-2"}
        bodyClassName={() => "!p-0 !m-0"}
      />
    </>
  );
}

export default NewDashLayout;
